import React from "react";
import { Flex, HStack, Image, Stack, Text } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../../Resources/Images/Logos/logo.svg";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const footerLinks = [
    { path: "/bulletin", text: t("footer.news") },
    { path: "/about", text: t("footer.about") },
    { path: "/FAQ", text: t("footer.faq") },
    { path: "/document", text: t("footer.documents") },
  ];

  return (
    <Flex
      as="footer"
      direction="column"
      justify="center"
      align="flex-end"
      w="100%"
      minH="278px"
      px={{ base: "20px", md: "32px", lg: "50px" }}
      py="50px"
      gap="30px"
      bg="#F2EEE5"
    >
      <Flex
        w="100%"
        justify="space-between"
        align="center"
        gap={{ base: "24px", lg: "60px" }}
        direction={{ base: "column", lg: "row" }}
      >
        <NavLink
          to="/"
          style={{ textDecoration: "none", alignSelf: "flex-start" }}
        >
          <Image
            src={logo}
            alt="數位證明管理中心"
            h={{ base: "40px", md: "44px", lg: "50px" }}
            w="auto"
            objectFit="contain"
            display="block"
          />
        </NavLink>

        <HStack
          as="nav"
          spacing="22px"
          flexWrap="wrap"
          justify={{ base: "flex-start", lg: "flex-end" }}
          w={{ base: "100%", lg: "auto" }}
        >
          {footerLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              style={{ textDecoration: "none" }}
            >
              <Flex
                h="37px"
                px="12px"
                py="8px"
                align="center"
                justify="center"
                borderRadius="4px"
                bg="transparent"
                transition="all 0.2s ease"
                _hover={{
                  bg: "rgba(0, 102, 153, 0.08)",
                }}
              >
                <Text
                  fontFamily="'Open Sans', sans-serif"
                  fontSize="14px"
                  fontWeight="400"
                  lineHeight="150%"
                  letterSpacing="0.01em"
                  textAlign="center"
                  color="#006699"
                  whiteSpace="nowrap"
                >
                  {link.text}
                </Text>
              </Flex>
            </NavLink>
          ))}
        </HStack>
      </Flex>

      <Stack
        spacing="30px"
        align="flex-end"
        w="100%"
        pr={{ base: "0", lg: "12px" }}
      >
        <Stack spacing="5px" align="flex-end">
          <Text
            fontFamily="'Open Sans', sans-serif"
            fontSize="14px"
            fontWeight="600"
            lineHeight="150%"
            letterSpacing="0.01em"
            textAlign="right"
            color="#000000"
          >
            國立成功大學電子證書服務小組
          </Text>

          <Text
            fontFamily="'Open Sans', sans-serif"
            fontSize="14px"
            fontWeight="400"
            lineHeight="150%"
            letterSpacing="0.01em"
            textAlign="right"
            color="#000000"
          >
            dcert-service@netdb.csie.ncku.edu.tw
          </Text>
        </Stack>

        <Text
          fontFamily="'Open Sans', sans-serif"
          fontSize="14px"
          fontWeight="400"
          lineHeight="150%"
          letterSpacing="0.01em"
          textAlign="right"
          color="#000000"
        >
          Copyright 2026 版權所有© 國立成功大學資訊工程系｜
          {(window as any).env.VERSION}｜更新日期：
          {(window as any).env.LAST_UPDATED}
        </Text>
      </Stack>
    </Flex>
  );
};

export default Footer;
